import Vue from 'vue'
import Vuex from 'vuex'
import upload from './modules/upload'
import { pauseAudio, playAudio } from '../utils/audio'
import { getStorage, setStorage } from '../utils/local-storage'
import { getAllMusicList } from '@/api/index'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    allMusicList: [],
    selectedList: getStorage('selectedList') || [],
    selectedIdList: getStorage('selectedIdList') || [],
    isPlay: false
  },
  mutations: {
    updateAllMusicList (state, list) {
      list.forEach(item => (item.isOpen = true))
      state.allMusicList = [...state.allMusicList, ...list]
    },
    updateSelectedList (state, { type = 'push', music }) {
      if (type === 'push') {
        state.isPlay && playAudio(music)
        state.selectedIdList.push(music.id)
        state.selectedList.push({ ...music })
      } else if (type === 'remove') {
        pauseAudio(state.selectedList[music.index]) // 暂停
        state.selectedIdList.splice(music.index, 1)
        state.selectedList.splice(music.index, 1)
      }
      setStorage('selectedList', state.selectedList)
      setStorage('selectedIdList', state.selectedIdList)
    },
    updateIsPlay (state, bool) {
      state.isPlay = bool
    }
  },
  actions: {
    async getAllMusicList ({ commit }) {
      const res = await getAllMusicList({})
      const data = res.data
      if (Number(data.code) === 0) {
        commit('updateAllMusicList', data.data.list)
      }
    }
  },
  modules: {
    upload
  }
})
